<template>
  <div>
    <el-image :src="href" crossorigin="anonymous" referrerpolicy="no-referrer" />
  </div>
</template>

<script>
export default {
  props: ["href"],
  data() {
    return {
      src: null,
      info: {
        name: "",
        image: ""

      },
      errors: []
    };
  },

  created() {

  },

  methods: {



  }
};

</script>
